export default function formatUsername(username: string, socialMediaKey: string) {
    if (socialMediaKey === "mastodon") {
        return username.charAt(0) === "@" ? username : "@" + username;
    }
    return username.charAt(0) === "@" ? username.substring(1) : username;
}
